module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAAXNSR0IB2cksfwAAABtQTFRFAAAA////////////////////////////////600+wgAAAAl0Uk5TAFBg8DD/7+DQvVE1SQAAAGlJREFUeJylibkNgDAAxE48A7ABAtIjnh4RpFCioGOSjMDg5CMlDa4sG3BUSGRjnbzdBsxXyFMjazLkld0gGLKglg1jphsx047VunTZDgMURnjXaoEK2Y9bRNc7wBd8+oHyv89kj5w88QCBBDAtZnpAjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--home-selected.png
// module id = 931
// module chunks = 0